export default __webpack_public_path__ + "static/media/logo-mark.0a3aeed2.png";